function parseTimeToSeconds(value) {
  if (typeof value !== 'string' || !value.trim()) return null;
  var parts = value.split(':').map(function (part) { return Number(part); });
  if (parts.length < 2 || parts.length > 3) return null;
  var hh = parts[0];
  var mm = parts[1];
  var ss = parts.length > 2 ? parts[2] : 0;
  if (![hh, mm, ss].every(function (n) { return Number.isInteger(n); })) return null;
  if (hh < 0 || hh > 23 || mm < 0 || mm > 59 || ss < 0 || ss > 59) return null;
  return (hh * 3600) + (mm * 60) + ss;
}

function dateParts(at) {
  var d = at instanceof Date ? at : new Date(at);
  if (!Number.isFinite(d.getTime())) {
    return { date: null, dayOfWeek: null, secondsOfDay: null };
  }
  var yyyy = d.getFullYear();
  var mm = String(d.getMonth() + 1).padStart(2, '0');
  var dd = String(d.getDate()).padStart(2, '0');
  return {
    date: yyyy + '-' + mm + '-' + dd,
    dayOfWeek: d.getDay(),
    secondsOfDay: (d.getHours() * 3600) + (d.getMinutes() * 60) + d.getSeconds(),
  };
}

function normalizeDays(days) {
  if (!Array.isArray(days)) return [];
  var seen = {};
  return days.map(function (d) { return Number(d); }).filter(function (d) {
    if (!Number.isInteger(d) || d < 0 || d > 6 || seen[d]) return false;
    seen[d] = true;
    return true;
  }).sort(function (a, b) { return a - b; });
}

function normalizeDateOnly(value) {
  if (value instanceof Date && Number.isFinite(value.getTime())) {
    var yyyy = value.getFullYear();
    var mm = String(value.getMonth() + 1).padStart(2, '0');
    var dd = String(value.getDate()).padStart(2, '0');
    return yyyy + '-' + mm + '-' + dd;
  }
  if (value == null) return null;
  var raw = String(value);
  return raw.length >= 10 ? raw.slice(0, 10) : raw;
}

function normalizeEligibilityWindow(window, fallback, index) {
  var source = window && typeof window === 'object' ? window : {};
  var base = fallback && typeof fallback === 'object' ? fallback : {};
  return {
    label: source.label || null,
    date_range_start: normalizeDateOnly(source.date_range_start || source.dateRangeStart || base.date_range_start),
    date_range_end: normalizeDateOnly(source.date_range_end || source.dateRangeEnd || base.date_range_end),
    daypart_start: source.daypart_start || source.daypartStart || base.daypart_start || null,
    daypart_end: source.daypart_end || source.daypartEnd || base.daypart_end || null,
    days_of_week: normalizeDays(source.days_of_week || source.daysOfWeek || base.days_of_week),
    position: Number.isInteger(Number(source.position)) ? Number(source.position) : index,
  };
}

function normalizeEligibilityWindows(rawWindows, legacy) {
  if (Array.isArray(rawWindows) && rawWindows.length > 0) {
    return rawWindows.map(function (window, index) {
      return normalizeEligibilityWindow(window, legacy, index);
    }).filter(function (window) {
      return window.daypart_start && window.daypart_end;
    });
  }
  var hasLegacyDaypart = !!(legacy.daypart_start && legacy.daypart_end);
  var hasLegacyDays = Array.isArray(legacy.days_of_week) && legacy.days_of_week.length > 0;
  if (!hasLegacyDaypart && !hasLegacyDays) return [];
  return [normalizeEligibilityWindow({
    daypart_start: legacy.daypart_start,
    daypart_end: legacy.daypart_end,
    days_of_week: legacy.days_of_week,
  }, legacy, 0)];
}

function normalizeCandidate(candidate, fallbackOrder) {
  if (!candidate || typeof candidate !== 'object') return null;
  var creativeId = candidate.creative_id || candidate.creativeId || null;
  if (!creativeId) return null;
  var order = Number(candidate.rotation_order != null ? candidate.rotation_order : candidate.rotationOrder);
  var assetUrl = candidate.asset_url || candidate.assetUrl || null;
  var days = normalizeDays(candidate.days_of_week || candidate.daysOfWeek);
  var eligibilityWindows = normalizeEligibilityWindows(candidate.eligibility_windows || candidate.eligibilityWindows, {
    daypart_start: candidate.daypart_start || candidate.daypartStart || null,
    daypart_end: candidate.daypart_end || candidate.daypartEnd || null,
    days_of_week: days,
  });
  var firstWindow = eligibilityWindows[0] || null;
  return {
    creative_id: String(creativeId),
    ...(candidate.creative_feedback && typeof candidate.creative_feedback === 'object' && !Array.isArray(candidate.creative_feedback)
      ? { creative_feedback: { ...candidate.creative_feedback } } : {}),
    creative_source: candidate.creative_source || candidate.creativeSource || null,
    asset_url: assetUrl,
    original_asset_url: candidate.original_asset_url
      || candidate.originalAssetUrl
      || candidate._trillboards_original_asset_url
      || assetUrl,
    media_type: candidate.media_type
      || candidate.mediaType
      || candidate._trillboards_media_type
      || null,
    rotation_order: Number.isInteger(order) && order >= 0 ? order : fallbackOrder,
    daypart_start: candidate.daypart_start || candidate.daypartStart || (firstWindow && firstWindow.daypart_start) || null,
    daypart_end: candidate.daypart_end || candidate.daypartEnd || (firstWindow && firstWindow.daypart_end) || null,
    days_of_week: days.length > 0 ? days : ((firstWindow && firstWindow.days_of_week) || []),
    eligibility_windows: eligibilityWindows,
  };
}

function candidateMatchesDayOfWeek(candidate, at) {
  var days = Array.isArray(candidate.days_of_week) ? candidate.days_of_week : [];
  if (days.length === 0) return true;
  var parts = dateParts(at);
  return parts.dayOfWeek == null || days.indexOf(parts.dayOfWeek) >= 0;
}

function candidateMatchesDaypart(candidate, at) {
  var start = parseTimeToSeconds(candidate.daypart_start);
  var end = parseTimeToSeconds(candidate.daypart_end);
  if (start == null && end == null) return true;
  if (start == null || end == null) return false;
  if (start === end) return true;
  var parts = dateParts(at);
  if (parts.secondsOfDay == null) return true;
  if (start < end) return parts.secondsOfDay >= start && parts.secondsOfDay < end;
  return parts.secondsOfDay >= start || parts.secondsOfDay < end;
}

function candidateMatchesDateRange(candidate, at) {
  var start = normalizeDateOnly(candidate.date_range_start);
  var end = normalizeDateOnly(candidate.date_range_end);
  if (!start && !end) return true;
  var parts = dateParts(at);
  if (!parts.date) return true;
  if (start && parts.date < start) return false;
  if (end && parts.date > end) return false;
  return true;
}

function candidateMatchesEligibility(candidate, at) {
  var windows = Array.isArray(candidate.eligibility_windows) ? candidate.eligibility_windows : [];
  if (windows.length === 0) {
    return candidateMatchesDayOfWeek(candidate, at) && candidateMatchesDaypart(candidate, at);
  }
  return windows.some(function (window) {
    return candidateMatchesDateRange(window, at)
      && candidateMatchesDayOfWeek(window, at)
      && candidateMatchesDaypart(window, at);
  });
}

function selectCreativeForSegmentRotation(segment, options) {
  var opts = options || {};
  var rotation = segment && segment.creative_rotation && typeof segment.creative_rotation === 'object'
    ? segment.creative_rotation
    : null;
  var rawCandidates = rotation && Array.isArray(rotation.candidates) ? rotation.candidates : [];
  var candidates = rawCandidates.map(function (candidate, index) {
    return normalizeCandidate(candidate, index);
  }).filter(Boolean).sort(function (a, b) {
    return a.rotation_order - b.rotation_order || a.creative_id.localeCompare(b.creative_id);
  });
  var fallbackId = rotation && rotation.default_creative_id
    ? rotation.default_creative_id
    : (segment && segment.reserved_alot_id ? segment.reserved_alot_id : null);
  var fallback = candidates.find(function (candidate) {
    return fallbackId && candidate.creative_id === fallbackId;
  }) || (fallbackId ? { creative_id: fallbackId, creative_source: null, rotation_order: 0 } : null) || candidates[0] || null;

  if (candidates.length <= 1) {
    return {
      creative_id: fallback ? fallback.creative_id : null,
      ...(fallback && fallback.creative_feedback ? { creative_feedback: { ...fallback.creative_feedback } } : {}),
      creative_source: fallback ? fallback.creative_source : null,
      asset_url: fallback ? fallback.asset_url || null : null,
      original_asset_url: fallback ? fallback.original_asset_url || fallback.asset_url || null : null,
      media_type: fallback ? fallback.media_type || null : null,
      reservation_id: rotation ? rotation.reservation_id || null : null,
      rotation_policy: rotation ? rotation.policy || null : null,
      candidate_count: candidates.length,
      eligible_candidate_count: candidates.length,
      used_default_fallback: false,
    };
  }

  var at = opts.at || opts.now || Date.now();
  var eligible = candidates.filter(function (candidate) {
    return candidateMatchesEligibility(candidate, at);
  });
  if (eligible.length === 0) {
    return {
      creative_id: fallback ? fallback.creative_id : null,
      ...(fallback && fallback.creative_feedback ? { creative_feedback: { ...fallback.creative_feedback } } : {}),
      creative_source: fallback ? fallback.creative_source : null,
      asset_url: fallback ? fallback.asset_url || null : null,
      original_asset_url: fallback ? fallback.original_asset_url || fallback.asset_url || null : null,
      media_type: fallback ? fallback.media_type || null : null,
      reservation_id: rotation ? rotation.reservation_id || null : null,
      rotation_policy: rotation.policy || null,
      candidate_count: candidates.length,
      eligible_candidate_count: 0,
      used_default_fallback: true,
    };
  }
  var cycleNumber = Math.max(0, Math.floor(Number(opts.cycleNumber != null ? opts.cycleNumber : opts.cycle_number) || 0));
  var selected = eligible[cycleNumber % eligible.length];
  return {
    creative_id: selected.creative_id,
    ...(selected.creative_feedback ? { creative_feedback: { ...selected.creative_feedback } } : {}),
    creative_source: selected.creative_source,
    asset_url: selected.asset_url || null,
    original_asset_url: selected.original_asset_url || selected.asset_url || null,
    media_type: selected.media_type || null,
    reservation_id: rotation ? rotation.reservation_id || null : null,
    rotation_policy: rotation.policy || null,
    candidate_count: candidates.length,
    eligible_candidate_count: eligible.length,
    rotation_order: selected.rotation_order,
    used_default_fallback: false,
  };
}

var __testing = {
  parseTimeToSeconds: parseTimeToSeconds,
  candidateMatchesDaypart: candidateMatchesDaypart,
  candidateMatchesDayOfWeek: candidateMatchesDayOfWeek,
  candidateMatchesEligibility: candidateMatchesEligibility,
};

export {
  selectCreativeForSegmentRotation,
  __testing,
};
